import { BgColorMap } from './constants';
import { DeprecatedBgColor, BgColor, CTABtnColor } from './types';

export const getBgColor = (
  backgroundColor: DeprecatedBgColor | BgColor
): BgColor => {
  return BgColorMap[backgroundColor] || backgroundColor;
};

export const getCtaBtnColor = (
  bgColor: DeprecatedBgColor | BgColor,
  ctaBtnColor?: CTABtnColor
) => {
  // Converts any deprecated V4 values to V5 background colors
  const background = getBgColor(bgColor);
  const allowedButtonTypes: {
    [key in BgColor]: (CTABtnColor | undefined)[];
  } = {
    // Note: Value present at 0th Index is considered as the default color value
    neutral100: ['primary', 'primary-alt', 'brand'],
    zapier: ['primary-alt'],
    night: ['primary-dark', 'brand'],
    moss: ['primary-dark', 'brand'],
    neutral800: ['primary-dark', 'brand'],
    earth: ['primary-dark', 'brand'],
  };

  if (ctaBtnColor && allowedButtonTypes[background].includes(ctaBtnColor)) {
    return ctaBtnColor;
  }
  // return default if no button color supplied
  return allowedButtonTypes[background][0];
};
